<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
            text-key="name"
            value-key="dCode"
            :search="true"
  >

    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).name}} -- {{findValueObject(scope.value).dCode}}
    </template>
    <template slot="option" slot-scope="scope">
      {{scope.option.name }} (+{{scope.option.dCode }})
    </template>

  </fvSelect>
</template>

<script>

	const countryCode = require("../../static/country")

	export default {
		props: {
			placeholder: {
				type: String
			},
			id: {
				type: String
			},
			value: {
				type: [String, Number],
			},
			required: [Boolean, Function],
		},
		data() {
			return {
				options: [],
			}
		},

		computed: {
			valData: {
				get() {
					return this.value + ''
				},
				set(value) {
					this.$emit('input', value)
				}
			}
		},
		methods: {
			findValueObject(value) {
				return this.options.find((option) => option.dCode === value) || false;
			},
		},
		mounted() {
			const result = []
			countryCode.forEach((val, index) => {
				const find = countryCode.find((inVal, inIndex) => val.dCode === inVal.dCode && index !== inIndex)

				if (find) {
					if (result.findIndex(inVal => inVal.dCode === find.dCode) === -1)
						result.push({name: `${val.name} , ${find.name}`, dCode: val.dCode})
				} else
					result.push(val)
			})
			this.options = result
		}
	}
</script>
